const TIERS = [
  {
    name: "Sprint",
    price: "$24k",
    cadence: "2-week engagement",
    description: "A short, focused discovery to pressure-test scope before you invest.",
    features: [
      "Stakeholder interviews",
      "Opportunity map + recommendation",
      "Prototype of the riskiest idea",
      "Written hand-off doc",
    ],
    cta: "Start a sprint",
    featured: false,
  },
  {
    name: "Build",
    price: "From $95k / mo",
    cadence: "Embedded squad",
    description: "A senior cross-functional pod working alongside your team to ship the next milestone.",
    features: [
      "Product + design + 2 engineers",
      "Weekly demos, monthly steering",
      "Shared roadmap + Linear board",
      "Production handover at completion",
    ],
    cta: "Talk to us",
    featured: true,
  },
  {
    name: "Steward",
    price: "From $18k / mo",
    cadence: "Ongoing partnership",
    description: "Trusted on-call partners for product reviews, hard problems, and the occasional fire.",
    features: [
      "Quarterly strategy sessions",
      "On-call architecture reviews",
      "Hiring + interview support",
      "Priority access to the team",
    ],
    cta: "Become a partner",
    featured: false,
  },
];

export default function Pricing() {
  return (
    <section className="section" id="pricing">
      <div className="container">
        <header className="section-header">
          <p className="section-eyebrow">Engagements</p>
          <h2 className="section-title">Three ways to work together.</h2>
          <p className="section-lede">
            Pick the shape that fits the moment — and change it when the moment changes.
          </p>
        </header>
        <div className="tier-grid">
          {TIERS.map((tier) => (
            <article
              key={tier.name}
              className={tier.featured ? "tier tier-featured" : "tier"}
            >
              {tier.featured && <span className="tier-badge">Most popular</span>}
              <h3 className="tier-name">{tier.name}</h3>
              <p className="tier-price">{tier.price}</p>
              <p className="tier-cadence">{tier.cadence}</p>
              <p className="tier-description">{tier.description}</p>
              <ul className="tier-features">
                {tier.features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
              <a
                href="#contact"
                className={
                  tier.featured ? "btn btn-primary btn-large" : "btn btn-large"
                }
              >
                {tier.cta}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
